define.alias("shared/components/shared/ui/switcher", "media/components/shared/ui/switcher");